// extracted by mini-css-extract-plugin
export var card = "_8l-1";
export var container = "_8l-0";